import Vue from 'vue';
import { common } from '@tencent/ceiba-base-components';
import { queryGameInfo } from '../tgclubApi';

const getGameInfoData = async  (gid) => {
  if (!gid) return  {};
  const response = await queryGameInfo(gid);
  console.info('queryGameInfo response =', response);
  if (!response) return  {};
  const  gameInfo = {};
  if (response.ret  !== 0) {
    console.error('get queryGameInfo error msg = ', response);
    return gameInfo;
  }
  if (parseInt(response.ret, 10) === 0) {
    const data = response.info || {};
    if (!data.androidPkgName) {
      console.error('download androidPkgName params empty ', response);
    }
    data.icon = typeof data.icon === 'string' && data.icon ? JSON.parse(data.icon) : data.icon;
    if (data.icon) {
      gameInfo.icon = !!data.icon[108] === true ? data.icon[108] : data.icon[16];
    } else {
      gameInfo.icon  = '';
    }
    gameInfo.packagename = data?.androidPkgName ?? '';
    gameInfo.version = data?.version ?? '';
    gameInfo.gamename = data?.gameName ?? '';
    gameInfo.channelid = data?.channelNum ?? '';
    gameInfo.iosurl = data?.IOSDownloadUrl ?? '';
    gameInfo.url = data?.androidDownloadUrl  ?? '';
    gameInfo.iOSPkgName = data?.iosPkgName || data?.androidPkgName || '';
    gameInfo.gid = data?.gid ?? '';
    gameInfo.gameAppID = data?.ext2;
    gameInfo.from = '1015';
    gameInfo.activityId = Vue.prototype?.$actInfo?.activity_id ?? 0;
    if (common.tool.getQueryparams('adreport') !== null) {
      gameInfo.from += `*${common.tool.getQueryparams('adreport')}`;
    }
  }
  return gameInfo;
};

const callAndDownLoadGame = (() => {
  let gameInfo  =  {};
  return async function ({ isNeedDownload, targetGameInfo }) {
    console.log('------------callAndDownLoadGame function  is access ', isNeedDownload, Vue.prototype?.$actInfo?.activity_id);
    console.log('------------callAndDownLoadGame function targetGameInfo = ', targetGameInfo);
    if (!window.Tgclub)   return false;
    if (!gameInfo.packagename) {
      gameInfo =  { ...targetGameInfo };
    }
    if (!gameInfo.packagename)  return  false;
    if (!gameInfo.iosurl)  return  false;
    if (!gameInfo.url)  return  false;
    const jsonStr = JSON.stringify(gameInfo);
    if (common.platform.isIos) {
      window.Tgclub.downloadApp(jsonStr, (ret) => {
        /* eslint-disable-next-line */
        var jsonArr = JSON.parse(ret);
      });
      window.Tgclub.downloadViewShow(jsonStr);
      return true;
    }
    const channelId = window.Tgclub.getAppChannelInfo(gameInfo.packagename, 'channelId');
    console.log('------------callAndDownLoadGame check channelId = ', channelId);

    if (channelId && typeof window.Tgclub.callExtendApp === 'function' && channelId > 0) {
      window.Tgclub.callExtendApp(`tgclub://${gameInfo.packagename}`);
      return true;
    }
    if (isNeedDownload) {
      let queryData = window.Tgclub.checkDownloadState(gameInfo.url);
      queryData = queryData ? JSON.parse(queryData)  : {} ;
      console.log('------- download----------queryData-----------', queryData);
      const { state = 1 } = queryData;
      switch (state) {
        case 0:
          window.Tgclub.downloadApp(jsonStr, (ret) => {
            /* eslint-disable-next-line */
            var jsonArr = JSON.parse(ret);
          });
          Vue.prototype?.$toast(`${gameInfo.gamename ||  '游戏'}开始下载中`);
          break;
        case 1:
          window.Tgclub.downloadApp(jsonStr, (ret) => {
            /* eslint-disable-next-line */
            var jsonArr = JSON.parse(ret);
          });
          Vue.prototype?.$toast(`${gameInfo.gamename ||  '游戏'}开始下载中`);
          break;
        case 2:
          Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
          break;
        case 3:
          window.Tgclub.continueDownloadApp(gameInfo.url);
          Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
          break;
        case 4:
          // 安装游戏
          window.Tgclub.installDownloadApp(gameInfo.url);
          Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}准备安装中`);
          break;
        default:
          break;
      }
      return  false;
    }
  };
})();

export  {
  callAndDownLoadGame,
  getGameInfoData,
};
export  default  {
  callAndDownLoadGame,
  getGameInfoData,
};
